import React, { Component } from 'react';
import './header.scss';
import Logo from '../../assets/images/logo.png';
import {
    Navbar,
    NavbarBrand,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Input,
    Button,
    Badge,
    Form,
    FormGroup
} from 'reactstrap';
import withAuth from '../../components/Services/WithAuth';
import AuthService from '../../components/Services/AuthService';
import { Link } from "react-router-dom";
import * as constant from '../../constants';
import MyAutosuggest from '../../components/ReusableComponents/AutoSuggest/index';

class Header extends Component {
    constructor(props, state) {
        super(props, state);
        //this.state = {showSide:false,showTop:false};
        this.Auth = new AuthService();
        this.state = {
            dropdownOpen: false,
            selected: "Name",
            searchText: "",
            class: "form-search d-sm-flex d-none",
            showSearchBox: false,
            selectedCountryName : "India",
            selectedCountryCode : "IN"
        };
    }

    componentDidMount() {
               
    }
    componentDidUpdate(prevProps) {
        let updatedStateObject = {}
        if (this.props.searchText !== prevProps.searchText) {
            updatedStateObject.searchText = this.props.searchText
            if (window.location.pathname !== "/" || window.location.pathname !== "/home") {
                this.props.showHideMenu();
            } 
        }
        if (this.props.searchParam !== prevProps.searchParam) {
            updatedStateObject.selected = this.props.searchParam
        }

        if (this.props.countryName !== prevProps.countryName) {
            updatedStateObject.selectedCountryName = this.props.countryName
        }

        if (this.props.countryCode !== prevProps.countryCode) {
            updatedStateObject.selectedCountryCode = this.props.countryCode
        }

        if (Object.keys(updatedStateObject).length > 0) {
            this.setState(updatedStateObject)
        }
        
    }


    handleLogout = () => {
        this.Auth.logout();
        this.props.logout()

    }

    handleGlobalSearch = (e) => {
        if (e.key === constant.ENTER) {
            e.preventDefault()
            this.props.handleSearch(this.state.selected, e.target.value,this.state.selectedCountryCode,this.state.selectedCountryName);
            // this.setState({
            //     class: "form-search d-sm-flex d-none"
            // })
        }
    }
    handleSelect = (e, param) => {
        e.preventDefault();
        this.setState({
            selected: param, dropdownOpen: false
        })
    }
    handleChange = (e) => {
        this.setState({ searchText: e.target.value })
    }

    handleMobileSearch = () => {
        if (window.innerWidth <= 800) {
            this.setState({
                class: "form-search d-flex", showSearchBox: true
            })
        }
    }

    handleCloseInput = () => {
        if (window.innerWidth <= 800) {
            if (this.state.showSearchBox) {
                this.setState({
                    class: "form-search d-none", showSearchBox: false
                })
            }
        }
    }

    toggleSearchDD = () => {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }
    searchCallback = (selected, type) => {
        this.setState({
            selectedCountryName: selected.value, selectedCountryCode: selected.id
        })
    }

    render() {
        const { value } = this.state;
        let inputProps = {
            placeholder: "Search Country",
            value,
            onChange: this.onChange,
            className: "form-control"
        };
        let searchDropDown;
        if(this.state.selectedCountryCode === constant.INDIA_COUNTRY_CODE){
            searchDropDown = <ul className={this.state.dropdownOpen ? "dropdown-menu global-search-dd-menu d-block w-100" : "dropdown-menu d-none w-100"}><li className="py-2 px-3"><a onClick={(e) => this.handleSelect(e, "Name")} className="global-search-dd-menu-item" href="">Name</a></li><li className="p-2 px-3"><a onClick={(e) => this.handleSelect(e, "GST")} className="global-search-dd-menu-item" href="">GST</a></li><li className="p-2 px-3"><a onClick={(e) => this.handleSelect(e, "PAN")} className="global-search-dd-menu-item" href="">PAN</a></li><li className="p-2 px-3"><a onClick={(e) => this.handleSelect(e, "CIN")} className="global-search-dd-menu-item" href="">CIN</a></li></ul>
        }else{
            searchDropDown = <ul className={this.state.dropdownOpen ? "dropdown-menu global-search-dd-menu d-block w-100" : "dropdown-menu d-none w-100"}><li className="py-2 px-3"><a onClick={(e) => this.handleSelect(e, "Name")} className="global-search-dd-menu-item" href="">Name</a></li></ul>
        }
        return (
            <header>
                <Navbar className="app-header fixed-top justify-content-start bg-light" expand="md">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="btn-left-nav mr-1 mt-1" onClick={!this.state.showSearchBox ? this.props.showHideMenu : this.handleCloseInput}>
                            <i className={this.state.showSearchBox ? 'icon-long-arrow-left-2' : 'icon-menu'}></i>
                        </div>
                        <NavbarBrand className={this.state.showSearchBox ? 'd-none' : 'd-inline-block'} href="/">
                            <img src={Logo} alt="logo" width="110" height="28" />&nbsp;
                            {(this.props.corporateLogo) ? <img src={this.props.corporateLogo} className="corporate-logo-display" alt="corporateLogo" height="28" /> : null}

                        </NavbarBrand>
                    </div>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    {this.props.globalSearchBoxShow && <div className="bg-white">
                        <MyAutosuggest
                            id='countrySearch'
                            placeholder="Search Country"
                            onChange={this.handleCountryAutocomplete}
                            searchCallback={this.searchCallback}
                            inputProps={inputProps}
                            searchType="countrySearch"
                            selectedValueCountry={this.state.selectedCountryName} /></div>}
                    <div className="d-flex justify-content-end justify-content-sm-between align-items-center flex-grow-1">
                        <Form className={this.state.class}>
                        {this.props.globalSearchBoxShow && <FormGroup className="mb-0 position-relative input-search w-100">
                                <i className="icon-search position-absolute search-icon-color" style={{'--primaryColor': this.props.corporateColor}}></i>
                                <Input type="search" name="search" id="search" placeholder={"Search Counterparty by " + this.state.selected} value={this.state.searchText}
                                    onChange={this.handleChange} onKeyPress={this.handleGlobalSearch} />
                                <i onClick={this.toggleSearchDD} className="icon-arrow-down position-absolute"></i>
                                {/*<i className="icon-close position-absolute d-sm-none" onClick={this.handleCloseInput}></i>*/}
                                {searchDropDown}
                                
                            </FormGroup>}
                        </Form>
                        
                        <div className={this.state.showSearchBox ? "app-header__right align-items-center justify-content-center d-none" : "app-header__right d-flex align-items-center justify-content-center"}>
                            <Button className="mr-2 btn-icon d-sm-none d-flex" /* onClick={this.props.showSearchResults} */ onClick={this.handleMobileSearch}>
                                <i className="icon-search"></i>
                            </Button>
                            {/* <Button className="mr-2 btn-icon position-relative btn-notification pointer" onClick={this.props.showHideSideBar}>
                                <i className="icon-notification"></i>
                                <Badge style={{ '--primaryColor': this.props.corporateColor }} className="position-absolute notification-count">{this.props.alertCount}</Badge>
                            </Button> */}
                            <UncontrolledDropdown className="dropdown-user">
                                <DropdownToggle caret className="dropdown-user__name dropdown-user__name-corporate px-3 d-flex align-items-center" style={{ '--primaryColor': this.props.corporateColor }}>
                                    <i className="icon-user mr-sm-3"></i> <span className="d-none d-sm-inline-block">{this.props.userInfo}</span>
                                </DropdownToggle>
                                <DropdownMenu className="px-3">
                                    <DropdownItem className="dropdown-user__item p-0" onClick={this.handleLogout}>
                                        <Link className="py-3 d-inline-block" to="/">Logout</Link>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    </div>
                </Navbar>
            </header>
        );
    }
}

export default withAuth(Header);
